import { useKeycloak } from '@react-keycloak/web'

export const useAuth = () => {
	const { keycloak } = useKeycloak()

	const isAuthenticated = keycloak?.authenticated ?? false
	const username = keycloak?.tokenParsed?.preferred_username
	const userEmail = keycloak?.tokenParsed?.email
	const token = keycloak?.token

	const realmRoles = keycloak?.tokenParsed?.realm_access?.roles ?? []
	const resourceRoles =
		keycloak?.tokenParsed?.resource_access?.['stenogramm-prod'].roles ?? []

	const isMain = resourceRoles.find(role => role.includes('main'))

	const isInt = resourceRoles.find(role => role.includes('int'))

	const isDev = resourceRoles.find(role => role.includes('dev'))

	return {
		keycloak,
		isAuthenticated,
		username,
		userEmail,
		token,
		realmRoles,
		resourceRoles,
		isMain,
		isInt,
		isDev,
		login: keycloak?.login,
		logout: keycloak?.logout
	}
}
